import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadHoldAtom = createMutationAtomFactory(
  'trade.purchaseLoadHold',
  (params: { id: string }) => ({
    tradePurchaseLoadHold: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
    },
  }),
);
